// The shared answer subconcepts (Yes/No/Unknown, Positive/Negative, Normal/Abnormal).
// Scripts name them, e.g. VALUE(DIR_ID(689), RESPONSE_YES); the parser resolves each
// name to its cid string, so they work anywhere a quoted cid does.
export const CommonResponses = {
	RESPONSE_YES: 'cKE3L7yoCdX8PzKSXXVKS1kF',
	RESPONSE_NO: 'c2s1CYRtjqvUzKYhAoyRAAy1',
	RESPONSE_UNKNOWN: 'cvip6pb5jAvh05YSF7wJC1qN',
	RESPONSE_POSITIVE: 'c9IR5Egp8F30gyqdnls0UiC4',
	RESPONSE_NEGATIVE: 'cmeaz807AtapeIJRg82lZsd2',
	RESPONSE_NORMAL: 'cgvdJ7DmtJqQaZWLoq3lNlEM',
	RESPONSE_ABNORMAL: 'cl3kFbYY66KdYH0qsB04FGtX',
} as const

export const isCommonResponse = (name: string): name is keyof typeof CommonResponses => {
	return Object.hasOwn(CommonResponses, name)
}
